import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AddDocumentTypeDialogData,
  ConfigSubmissions,
  ConfigSubmissionsData,
  DocumentAttribute,
  DocumentTypePayload,
  DocumentTypes,
  DocumentTypesData,
  DocumentTypesDialogData,
  IrisMapping,
  SDocumentPayload,
  SubmissionDialogData,
  SubmissionDocument,
} from '../types';

import { ComponentType } from '@angular/cdk/overlay';
import { WcgTableData } from '@wcg/frontend-framework';
import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
import { DELETE_DIALOG_DATA } from '@shared/dialogs/types';

/**
 * @Document Type Actions
 * */
const loadDocumentTypes = () => props<{ params: WcgTableValues }>();

const loadAttributes = () => props<{ params: WcgTableValues }>();

const onLoadAttributesSuccess = () =>
  props<{ documentAttributes: DocumentAttribute }>();

const onLoadAttributeFailure = () => props<{ error: Error }>();

const onLoadDocumentTypesSuccess = () =>
  props<{ documentTypes: DocumentTypes }>();

const onLoadDocumentTypesFailure = () => props<{ error: Error }>();

const createDocumentType = () =>
  props<{ data: DocumentTypePayload; wcgTableValues: WcgTableValues }>();

const onCreateDocumentTypeFailure = () => props<{ error: Error }>();

const updateDocumentType = () => props<{ data: DocumentTypePayload }>();

const onUpdateDocumentTypeSuccess = () => props<{ data: DocumentTypesData }>();

const onUpdateDocumentTypeFailure = () => props<{ error: Error }>();

const checkCanDeleteDocument = () => props<{ data: DocumentTypesData }>();

const deleteDocumentType = () =>
  props<{ documentId: string; message: string }>();
const onDeleteDocumentTypeSuccess = () => props<{ documentId: string }>();
const onDeleteDocumentTypeFailure = () => props<{ error: Error }>();

/**
 * @Document Type Actions End
 * **/

/*
 * @Document Set Table Data
 * */
const setDocumentTypesTableData = () => props<{ tableData: WcgTableData }>();
/*
 * @Document Set Table Data End
 * */

export const CONFIGURATION_DOCUMENT_TYPE_ACTIONS = createActionGroup({
  events: {
    checkCanDeleteDocument: checkCanDeleteDocument(),
    createDocumentType: createDocumentType(),
    deleteDocumentType: deleteDocumentType(),
    loadAttributes: loadAttributes(),
    loadDocumentTypes: loadDocumentTypes(),
    onCreateDocumentTypeFailure: onCreateDocumentTypeFailure(),
    onCreateDocumentTypeSuccess: emptyProps(),
    onDeleteDocumentTypeFailure: onDeleteDocumentTypeFailure(),
    onDeleteDocumentTypeSuccess: onDeleteDocumentTypeSuccess(),
    onLoadAttributeFailure: onLoadAttributeFailure(),
    onLoadAttributesSuccess: onLoadAttributesSuccess(),
    onLoadDocumentTypesFailure: onLoadDocumentTypesFailure(),
    onLoadDocumentTypesSuccess: onLoadDocumentTypesSuccess(),
    onUpdateDocumentTypeFailure: onUpdateDocumentTypeFailure(),
    onUpdateDocumentTypeSuccess: onUpdateDocumentTypeSuccess(),
    setDocumentTypesTableData: setDocumentTypesTableData(),
    updateDocumentType: updateDocumentType(),
  },
  source: '[Configurations] Document Type',
});

/**
 * @Submission Type Actions
 * */
const loadSubmissionList = () => props<{ params: WcgTableValues }>();

const onLoadsubmissionListSuccess = () =>
  props<{ submissions: ConfigSubmissions }>();

const onLoadsubmissionListFailure = () => props<{ error: Error }>();

const fetchSubmissionDocumentType = () =>
  props<{ submission: ConfigSubmissionsData }>();

const onFetchSubmissionDocumentTypeSuccess = () =>
  props<{
    submissionDocument: SubmissionDocument;
  }>();

const onFetchSubmissionDocumentTypeFailure = () => props<{ error: Error }>();

const updateSubmissionDocumentTypes = () => props<SDocumentPayload>();

const onUpdateSubmissionDocumentTypesFailure = () => props<{ error: Error }>();

const loadDocumentTypesForSubmission = () =>
  props<{
    submission: ConfigSubmissionsData;
  }>();

const onLoadDocumentTypesForSubmissionSuccess = () =>
  props<{ documentTypes: DocumentTypes }>();

const onLoadDocumentTypesForSubmissionFailure = () => props<{ error: Error }>();

const updateIrisSettings = () =>
  props<{
    id: string;
    irisMapping: IrisMapping;
    wcgTableValues: WcgTableValues;
    entityType: string;
  }>();

const onUpdateIrisSettingsFailure = () => props<{ error: Error }>();

const setsubmissionTableData = () => props<{ tableData: WcgTableData }>();

const fetchDocumentTypes = () =>
  props<{ typeId?: string; entityType?: string }>();

export const CONFIGURATION_SUBMISSION_TYPE_ACTIONS = createActionGroup({
  events: {
    fetchDocumentTypes: fetchDocumentTypes(),
    fetchSubmissionDocumentType: fetchSubmissionDocumentType(),
    loadDocumentTypesForSubmission: loadDocumentTypesForSubmission(),
    loadSubmissionList: loadSubmissionList(),
    onFetchSubmissionDocumentTypeFailure:
      onFetchSubmissionDocumentTypeFailure(),
    onFetchSubmissionDocumentTypeSuccess:
      onFetchSubmissionDocumentTypeSuccess(),
    onLoadDocumentTypesForSubmissionFailure:
      onLoadDocumentTypesForSubmissionFailure(),
    onLoadDocumentTypesForSubmissionSuccess:
      onLoadDocumentTypesForSubmissionSuccess(),
    onLoadsubmissionListFailure: onLoadsubmissionListFailure(),
    onLoadsubmissionListSuccess: onLoadsubmissionListSuccess(),
    onUpdateIrisSettingsFailure: onUpdateIrisSettingsFailure(),
    onUpdateIrisSettingsSuccess: emptyProps(),
    onUpdateSubmissionDocumentTypesFailure:
      onUpdateSubmissionDocumentTypesFailure(),
    onUpdateSubmissionDocumentTypesSuccess: emptyProps(),
    setsubmissionTableData: setsubmissionTableData(),
    updateIrisSettings: updateIrisSettings(),
    updateSubmissionDocumentTypes: updateSubmissionDocumentTypes(),
  },
  source: '[Configurations] Submission Type',
});
/*
 * @SUBMISSION ACTIONS END
 * */

/**
 * @DOCUMENT_DIALOG_ACTIONS
 * */
const loadSubmissionDialogData = () =>
  props<{
    entityType: string;
  }>();

const openConfigurationDialog = () =>
  props<{
    component: () => ComponentType<unknown>;
    data: DocumentTypesDialogData | AddDocumentTypeDialogData | SubmissionDialogData | DELETE_DIALOG_DATA;
    id?: string;
  }>();

const closeConfigurationDialog = () =>
  props<{
    component: () => ComponentType<unknown>;
  }>();

export const CONFIGURATION_DIALOG_ACTIONS = createActionGroup({
  events: {
    closeConfigurationDialog: closeConfigurationDialog(),
    loadSubmissionDialogData: loadSubmissionDialogData(),
    openConfigurationDialog: openConfigurationDialog(),
  },
  source: '[Configurations] Dialog Actions',
});
